import { writable } from 'svelte/store';
import { ChallengeService } from '../../services/challenge.service';
import { ChallengeTaskService } from '../../services/challenge-task.service';
export const loading = writable(false);
//export const filter = writable<ISearchFilterDTO<IChallenge>>(<any>{ criteria: {} });
export const records = writable([]);
//export const pagination = writable<IApiPagination>(null);
export async function initFilesList(sectionId, challengeId) {
    //filter.set({ criteria: <IChallenge>{ sectionId: sectionId, active: 1 }, params: null, sorting: "" });
    //pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    loadFiles(challengeId);
}
export async function loadFiles(challengeId) {
    loading.set(true);
    try {
        //let _filter = get(filter);
        //let _pag = get(pagination);
        let _resp = await ChallengeService.getChallengeSampleFiles(challengeId);
        records.set(_resp.payload);
        //pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function downloadSampleFile(taskId, fileType, fileName) {
    ChallengeTaskService.downloadChallengeTaskSample(taskId, fileType, fileName);
}
